module.exports = __webpack_public_path__ + "img/jakob-illek.69394df9.jpg";